<template>
  <div class="ProductInfo">
    <el-tabs type="border-card" :stretch="true">
      <el-tab-pane label="产品选择" >
        <span slot="label"><p class="el-icon-arrow-left back-icon" @click="back()"></p> 产品选择 </span>
        <div>
          <el-tabs tab-position="left" class="product-menu" @tab-click="selectType">
            <el-tab-pane :label=type.name v-for="(type,i) in types" :key="i">
              <div v-for="(s,j) in series" :key="j" style="float: left;width: 100%">
                <el-divider content-position="left" >{{s.name}}</el-divider>
                <div class="prolist-list" v-for="(p,k) in products" :key="k">
                  <div v-if="p.fid==s.id" class="prolist-div">
                    <div class="product-info">
                      <span>{{p.name}}</span>
                    </div>
                    <img :src="getImgUrl(p.name)" alt="" class="product-img" @click="handlePictureCardPreview(s.name,p)">
                  </div>
                </div>
              </div>

            </el-tab-pane>
          </el-tabs>
          <el-dialog
              :title="s_product.model"
              :visible.sync="dialogVisible"
              :modal-append-to-body='false'
              width="90%"
          >
<!--            <img :src="hqImgName" alt="" class="product-img-hq" preview="1" :preview-text="s_product.model">-->
            <img :src="hqImgName" alt="" class="product-img-hq">
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="chooseProduct">选择此产品</el-button>
            </span>
          </el-dialog>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
    export default {
        name: "ProductInfo",
        data(){
            return{
                // 选择
                s_product: {
                    type: '' , series: '' , model: '' , img: ''
                },
                selectedType:'智能家居',
                types: [
                    {id: 1 , name: '智能家居'}
                    // ,
                    // {id: 2 , name: 'LED'}
                    // ,
                    // {id: 3 , name: '生活电器'}
                ],
                series: [],
                products: [],
                dialogVisible: false,
                hqImgName: '',
                series1: [
                    {id: 1 , name: '智能锁'}
                    // ,
                    // {id: 2 , name: '智能开关'}
                    ],
                products1: [
                    {fid: 1 , name:'X1'},
                    {fid: 1 , name:'X3'},
                    {fid: 2 , name:'G27系列'},
                    // {fid: 1, name: '其他'},
                    {fid: 2, name: '其他'}
                ],
                series2: [
                    {id: 1 , name: '卧室灯'},
                    {id: 2 , name: '客厅灯'},
                    {id: 3 , name: '吸顶灯'},
                    {id: 4 , name: '吊灯'}
                ],
                products2: [
                    {fid: 1 , name:'MX-B048047A-BS'},
                    {fid: 1 , name:'MX-B048045C-BS'},
                    {fid: 1 , name:'MX-B048046C-BD'},
                    {fid: 1 , name:'MX-C048A-BS'},
                    {fid: 1 , name:'MX-B048045A-BS'},
                    {fid: 1 , name:'MX-B055046A-BS'},
                    {fid: 1 , name:'MX-B048045B-BS'},
                    {fid: 1 , name:'MX-B055046B-BS'},
                    {fid: 1 , name:'MX-B048046B-BD'},
                    {fid: 1 , name:'MX-C050055A-BE'},
                    {fid: 2 , name:'MX-C130092A-BS'},
                    {fid: 2 , name:'MX-C150093A-BS'},
                    {fid: 2 , name:'MX-C150093A-BD'},
                    {fid: 2 , name:'MX-C130086A-BS'},
                    {fid: 2 , name:'MX-C130095B-BE'},
                    {fid: 2 , name:'MX-C150A-BS'},
                    {fid: 2 , name:'MX-D082065A-BS'},
                    {fid: 3 , name:'MX-D128110A-BS'},
                    {fid: 3 , name:'MX-A012023A-AS'},
                    {fid: 3 , name:'MX-A018030A-AS'},
                    {fid: 3 , name:'MX-A024035D-BS24W'},
                    {fid: 3 , name:'MX-A024A-AS'},
                    {fid: 3 , name:'MX-A024C-AS'},
                    {fid: 3 , name:'MX-A024D-AS'},
                    {fid: 3 , name:'MX-A018030B-AS'},
                    {fid: 3 , name:'MX-A024035B-AS'},
                    {fid: 3 , name:'MX-A018030C-AS'},
                    {fid: 3 , name:'MX-B024035B-AS'},
                    {fid: 3 , name:'MX-B024035A-AS'},
                    {fid: 3 , name:'MX-B12440-A'},
                    {fid: 3 , name:'MX-B12440-B'},
                    {fid: 4 , name:'MF-A136A-BS'},
                    {fid: 4 , name:'MF-B069A-BS'},
                    {fid: 1, name: '其他'},
                    {fid: 2, name: '其他'},
                    {fid: 3, name: '其他'},
                    {fid: 4, name: '其他'}
                ],
                series3: [
                    {id: 1 , name: '浴霸'}
                ],
                products3: [
                    {fid: 1 , name:'MY-B2K4060C-AD'},
                    {fid: 1 , name:'MY-A2K4060A-AD'},
                    {fid: 1 , name:'MY-B2K4060D-BD'},
                    {fid: 1 , name:'MY-A2K4060B-BD'},
                    // {fid: 1, name: '其他'}
                ],

                // 记录路由来源，便于返回
                routeFrom: 'Index'
            }
        },
        mounted() {
            this.s_product.type = this.types[0].name;
            this.series = this.series1;
            this.products = this.products1;
        },
        // 记录路由来源，便于返回
        beforeRouteEnter(to,from,next){
            next(vm => {
                if(from.name) {
                    vm.routeFrom = from.name
                }
            })
        },
        methods:{
            // 页面右上角 < 路由返回
            back(){
                this.$router.back();
            },
            // 获取图片地址，@/assets/propic/型号名.png
            getImgUrl(name){
                if(name.endsWith("系列")){
                    name = name.slice(0,name.length-2);
                }
                return require('@/assets/propic/'+name+'.png');
            },
            getHQImgUrl(name){
                if(name.endsWith("系列")){
                    name = name.slice(0,name.length-2);
                }
                return require('@/assets/HQ/'+name+'-HQ.png');
            },
            // 选择左边栏菜单，即选择产品类别，右侧列表显示对应产品列表
            selectType(tab,event){
                // event.target.getAttribute('id')获取的是元素的id，此处为tab-0、tab-1、tab-2...
                const id = event.target.getAttribute('id').split("-")[1];
                // 选中的产品类别
                const t = this.types[id];
                this.selectedType = t.name;
                if('1'==t.id){
                    this.series = this.series1;
                    this.products = this.products1
                }else if('2'==t.id){
                    this.series = this.series2;
                    this.products = this.products2
                }else{
                    this.series = this.series3;
                    this.products = this.products3
                }
            },
            chooseProduct(){
                this.dialogVisible = false;
                if(this.s_product.model.endsWith("系列")){
                    this.s_product.model = this.s_product.model.slice(0,this.s_product.model.length-2);
                }
                this.$router.push({
                    name:this.routeFrom,
                    params: {
                        s_product: this.s_product
                    }
                })
            },
            // choosePro(name,p){
            //     this.s_product.img = this.getImgUrl('propic/'+p.name+'.png');
            //     this.s_product.series = name;
            //     this.s_product.model = p.name;
            //     this.s_product.type = this.selectedType;
            // },
            handlePictureCardPreview(seriesName,p){
                console.log(p.name);
                this.dialogVisible = true;
                this.s_product.type = this.selectedType;
                this.s_product.img = this.getImgUrl(p.name);
                this.s_product.series = seriesName;
                this.s_product.model = p.name;
                this.hqImgName = this.getHQImgUrl(p.name);
                this.$previewRefresh();
            }
        }
    }
</script>

<style scoped>
  .ProductInfo {
    height: 100%;
  }
  .ProductInfo > .el-tabs{
    height: 100%;
    position: relative;
    overflow: hidden;
  }
  .prolist-list {
    margin: 0px 0px 10px 0px;
    float: left;
    font-size: 12px;
    color: #999;
  }
  .product-info {
    height: 28px;
    display:flex;
    justify-content:center;
    align-items:center;
  }
  .ProductInfo > .el-tabs> .el-tabs__content > .el-tab-pane{
    height: 100%;
  }
  .ProductInfo > .el-tabs> .el-tabs__content > .el-tab-pane > div{
    height: 100%;
  }
  .ProductInfo > .el-tabs> .el-tabs__content > .el-tab-pane > div > .el-tabs{
    height: 100%;
  }
  .product-img-hq{
    width: 300px;
  }
</style>
<style>
  .ProductInfo .el-tabs__item {
    padding: 0px 10px!important;
  }
  .ProductInfo .el-tabs__content .el-tabs__content{
    height: 100%;
    overflow: scroll!important;
  }
  .ProductInfo > .el-tabs> .el-tabs__content {
    position: absolute!important;
    top: 40px;
    bottom: 0px;
  }
  .ProductInfo > .el-tabs> .el-tabs__content > .el-tab-pane > div > .el-tabs > .el-tabs__header{
    height: 120px;
  }
  .ProductInfo .el-dialog__body {
    padding: 0px!important;
  }
  .ProductInfo .el-dialog__footer {
    text-align: center;
  }
</style>
